import { render, staticRenderFns } from "./DetailedPalletTrazability.vue?vue&type=template&id=3db519c4"
import script from "./DetailedPalletTrazability.vue?vue&type=script&lang=js"
export * from "./DetailedPalletTrazability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports